import React from "react";
import { openUrl } from "@/utils";
import { useLocation } from "react-router";
import { getSubscribeUrl } from "@/services/subscribeServices";
import ShopType from "@/enum/ShopType";
import "./index.less";
import { Modal } from "antd";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import AppVersion from "@/enum/AppVersion";
import { createShopRenewRecord } from "@/services/api/shop";

function getImageUrl(shopType: ShopType, appVersion: string) {
    if ([ShopType.CHANNEL_SHOP].includes(shopType)) {
        return "https://img.alicdn.com/imgextra/i4/54458674/O1CN01GMA4se2DwkV9JISRG_!!54458674.png";
    }

    if ([ShopType.CHANNEL_SHOP_DROPSHIP, ShopType.CHANNEL_SHOP_SUPPLIER].includes(shopType)) {
        return "https://img.alicdn.com/imgextra/i1/54458674/O1CN013Pxtqe2DwkZ2c00hZ_!!54458674.png";
    }

    if (shopType === ShopType.PINDUODUO) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i3/54458674/O1CN012QJPU22DwkV7bR2Nx_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i4/54458674/O1CN01nuFysP2DwkV18qJzg_!!54458674.png";
        }
    }

    if (shopType === ShopType.KWAI_DROPSHIP) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01QRLI0p2DwkV7jd3ZA_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i3/54458674/O1CN019ANyJt2DwkV8eUh9U_!!54458674.png";
        }
    }

    if ([ShopType.JD_PURCHASE, ShopType.JD].includes(shopType)) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01xRHEkp2DwkV7nmz3f_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i1/54458674/O1CN013VfiOS2DwkV7u2x5Y_!!54458674.png";
        }
    }

    if (shopType === ShopType.KWAI) {
        return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01FCacuQ2DwkV9rTIDm_!!54458674.png";
    }

    if (shopType === ShopType.DOUDIAN_SUPPLIER) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i3/54458674/O1CN01Ps1MVf2DwkV8NJw3u_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i3/54458674/O1CN01PMS5Sq2DwkVAJEtGs_!!54458674.png";
        }
    }

    if (shopType === ShopType.DOUDIAN) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01SJY8ci2DwkV8eOiwY_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01i7aL3K2DwkV7jgc23_!!54458674.png";
        }
    }

    if (shopType === ShopType.ALIBABA) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01rdXH7D2DwkV8eOn5j_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i3/54458674/O1CN01LS9B3M2DwkV9LnL8j_!!54458674.png";
        }
    }

    if (shopType === ShopType.DOUDIAN_IOP) {
        if (appVersion === AppVersion.PREMIUM) {
            return "https://img.alicdn.com/imgextra/i4/54458674/O1CN01xGcvxa2DwkV9vajv7_!!54458674.png";
        } else {
            return "https://img.alicdn.com/imgextra/i2/54458674/O1CN010eJ4Zg2DwkV9PgLwt_!!54458674.png";
        }
    }

    if (shopType === ShopType.TAOBAO || shopType === ShopType.TAOBAO_DISTRIBUTION) {
        return "https://img.alicdn.com/imgextra/i1/54458674/O1CN01W7Y9kG2DwkV8NK0EB_!!54458674.png";
    }

    return null;
}

/**
 * 订阅确认提示页面，提示用户不要订错店铺和版本
 */
const RenewalConfirm: React.FC = React.memo(function () {
    const location = useLocation();

    const search = new URLSearchParams(location.search);

    const renewShopId = search.get("renewShopId");
    const renewShopName = search.get("renewShopName");
    const renewShopSellerUsername = search.get("renewShopSellerUsername");
    const renewShopType = search.get("renewShopType") as ShopType;
    const renewAppVersion = search.get("renewAppVersion");
    const opShopName = search.get("opShopName");
    const opShopSellerUsername = search.get("opShopSellerUsername");
    const opShopType = search.get("opShopType");
    const pageName = search.get("pageName");

    const imageUrl = getImageUrl(renewShopType, renewAppVersion);

    if (!imageUrl) {
        return (
            <div>
                <span>未补充该平台{renewShopType}</span>
            </div>
        );
    }

    return (
        <div className="renewal-confirm-v2">
            <div className="renewal-confirm-content">
                <img className="tip-image" src={imageUrl} alt="" style={{ width: "100%" }} />

                <div className="renewal-confirm-footer">
                    <div>
                        <button
                            className="confirm-button"
                            onClick={() => {
                                const gotoRenew = () => {
                                    const url = getSubscribeUrl(renewShopType);

                                    if (url) {
                                        openUrl(url);

                                        createShopRenewRecord({
                                            renewShopId,
                                            renewShopName,
                                            renewShopSellerUsername,
                                            renewShopType,
                                            renewAppVersion,
                                            opShopName,
                                            opShopSellerUsername,
                                            opShopType,
                                            pageName,
                                        });
                                    }
                                };

                                gotoRenew();

                                // if (renewShopName) {
                                //     Modal.info({
                                //         icon: null,
                                //         okCancel: true,
                                //         width: 500,
                                //         okText: "确认续费",
                                //         content: (
                                //             <div>
                                //                 <div>
                                //                     <span>要续费的店铺:</span>
                                //                     <span className="error ml5 fb fs20">
                                //                         {renewShopName}({ShopTypeNameMap[renewShopType]})
                                //                     </span>
                                //                 </div>
                                //                 <div className="mt10">
                                //                     <span>当前版本:</span>
                                //                     <span className="fb ml5">
                                //                         {renewAppVersion === AppVersion.PREMIUM ? "高级版" : "标准版"}
                                //                     </span>
                                //                 </div>
                                //                 <div className="error mt10 fb">
                                //                     (续费时请确认服务市场登录的是该店铺)
                                //                 </div>
                                //             </div>
                                //         ),
                                //         onOk() {
                                //             gotoRenew();
                                //         },
                                //     });
                                // } else {
                                //     gotoRenew();
                                // }
                            }}
                        >
                            点击前往订购
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default RenewalConfirm;
